import React, { useEffect } from "react";
import clsx from "clsx";
import { TwitterFollowButton } from "react-twitter-embed";

// import FooterImg1 from "../../../images/ark-footer-1.png";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  weight600: {
    fontWeight: 600,
  },
  font12: {
    fontSize: 12,
    fontWeight: 400,
  },
  centerAlign: {
    textAlign: "center",
    marginTop: theme.spacing(2.5),
  },
  cursor: {
    cursor: "pointer",
  },
  privacyLinkContainer: {
    maxWidth: "75%",
    margin: "0 auto",
  },
  marginTop20: {
    marginTop: 20,
  },
  twitterWidget: {},
}));

const ArkFooter = () => {
  const classes = useStyles();

  const handlePrivacyClick = () => {
    window.open("https://spiking.com/privacy", "_blank");
  };

  const handleTwiterClick = () => {
    window.open("https://twitter.com/spiking", "_blank");
  };

  const handleTermsClick = () => {
    window.open("https://spiking.com/terms", "_blank");
  };

  return (
    <Box mt={9}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection={{ xs: "column", md: "row" }}
      >
        <Box mr={1}>
          <TwitterFollowButton screenName={"Spiking"} />
        </Box>
        <Box>
          <TwitterFollowButton screenName={"ClemenChiang"} />
        </Box>
      </Box>

      <Grid container className={classes.privacyLinkContainer}>
        <Typography align="center" variant="subtitle1" color="textPrimary">
          ANY AND ALL CLAIMS OR REPRESENTATIONS, AS TO INCOME EARNINGS ON THE
          SITE, ARE NOT TO BE CONSIDERED AS AVERAGE EARNINGS. THERE CAN BE NO
          ASSURANCE THAT ANY PRIOR SUCCESSES, OR PAST RESULTS, AS TO INCOME
          EARNINGS, CAN BE USED AS AN INDICATION OF YOUR FUTURE SUCCESS OR
          RESULTS.MONETARY AND INCOME RESULTS ARE BASED ON MANY FACTORS. COMPANY
          HAS NO WAY OF KNOWING HOW WELL YOU WILL DO, AS THEY DO NOT KNOW YOU,
          YOUR BACKGROUND, YOUR WORK ETHIC, OR YOUR BUSINESS SKILLS OR
          PRACTICES. THEREFORE, COMPANY DOES NOT GUARANTEE OR IMPLY THAT YOU
          WILL GET RICH, THAT YOU WILL DO AS WELL, OR THAT YOU WILL MAKE ANY
          MONEY AT ALL. IF YOU RELY UPON FIGURES PROVIDED IN THE SITE; YOU MUST
          ACCEPT THE RISK OF NOT DOING AS WELL.
        </Typography>
        <Typography
          align="center"
          className={clsx(classes.font12, classes.marginTop20)}
          color="textPrimary"
        >
          These are the publicly-traded U.S. stocks as reported to the
          Securities and Exchange Commission in filings made available to the
          public. There are times when an insider asks for, and receives, the
          SEC's permission to temporarily withhold data on some stock holdings.
        </Typography>
      </Grid>

      <div className={classes.centerAlign}>
        {window.location.href.includes("ark") && (
          <Typography
            variant="subtitle1"
            className={classes.weight600}
            color="textPrimary"
          >
            <span>Spiking</span> is not affiliated with Ark Invest or Cathie
            Wood
          </Typography>
        )}

        {/* <Box my={1.5}>
          <Typography
            variant="subtitle1"
            color="primary"
            component="span"
            onClick={handlePrivacyClick}
            className={classes.cursor}
          >
            Privacy Policy
          </Typography>
          <Typography
            variant="subtitle1"
            color="primary"
            component="span"
            style={{ marginLeft: 30 }}
            onClick={handleTermsClick}
            className={classes.cursor}
          >
            Terms of Services
          </Typography>
        </Box> */}
        <Typography className={classes.font12} color="textPrimary">
          Graphs, numbers, and charts should only be taken as approximations. No
          warranty to the accuracy of the data on this website is provided by
          Spiking.
        </Typography>
        {/* <Box mt={1.5}>
          <Typography className={classes.font12}>@2021 Spiking LLC</Typography>
        </Box> */}
      </div>
      <Typography color="textPrimary">
        <div className="legal-privacy">
          <a
            href="https://spiking.com/legal"
            id="link-1460-246"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Legal
          </a>
          &nbsp; |&nbsp;{" "}
          <a
            href="https://spiking.com/privacy"
            id="link-1460-246"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          &nbsp; |&nbsp;
          <a
            href="https://spiking.com/terms"
            id="link-1460-246"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
          &nbsp; |&nbsp;
          <a
            href="https://spiking.com/earningsdisclaimer"
            id="link-5649-352"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Earnings Disclaimer
          </a>
          &nbsp; |&nbsp;
          <a
            href="https://spiking.com/financialdisclaimer"
            id="link-5649-352"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Financial Disclaimer
          </a>
          &nbsp;
          <br />
          <a
            href="https://spiking.com/affiliatedisclosure"
            id="link-1460-246"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Affiliate Disclosure
          </a>
          &nbsp; |&nbsp;
          <a
            href="https://spiking.com/eula"
            id="link-1460-246"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            EULA
          </a>
          &nbsp; |&nbsp;
          <a
            href="https://spiking.com/refund"
            id="link-1460-246"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Refund Policy
          </a>
          &nbsp; |&nbsp;
          <a
            href="https://spiking.com/donotsell"
            id="link-5649-352"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Don't Sell My Personal Information
          </a>
          &nbsp; |&nbsp;
          <a
            href="https://spiking.com/results"
            id="link-5649-352"
            class=""
            target="_blank"
            rel="noopener noreferrer"
          >
            Testimonials &amp; Results Disclosure
          </a>
          &nbsp;
          <br />
          Spiking.com - an Aly Product Company - All Rights Reserved @ 2016 -
          2023
          <br />
          Made with ❤️ in Singapore
        </div>
      </Typography>
    </Box>
  );
};

export default ArkFooter;
